// Extracts analytics props from a Stripe error. Handles both shapes:
//   - stripe.js client SDK rejections (handleCardPayment / handleNextAction)
//   - stripe-node errors serialized over the wire from /v4/stripe/confirmPayment
//
// `rawType ?? type` prefers the API enum ("card_error") over the stripe-node
// constructor name ("StripeCardError"). `message ?? raw?.message` covers
// modern stripe-node (enumerable own `message`) and legacy stripe-node
// (≤v8) where the top-level `message` is dropped during JSON serialization.
//
// Stripe API error schema: https://docs.stripe.com/api/errors
// stripe-node StripeError:  https://github.com/stripe/stripe-node/blob/master/src/Error.ts
export function getStripeErrorProperties(error: any) {
  return {
    'Error Code': error?.code,
    'Decline Code': error?.decline_code,
    'Error Type': error?.rawType ?? error?.type,
    'Error Message': error?.message ?? error?.raw?.message,
    'HTTP Status': error?.statusCode ?? error?.raw?.statusCode,
  }
}

// Stripe reports every card decline as a card_error, but under several error
// codes (card_declined, payment_intent_payment_attempt_failed, ...).
export function isStripeCardError(error: { type?: string; rawType?: string }) {
  return (error.rawType ?? error.type) === 'card_error'
}
